<template>
  <div class="card p-shadow-app image-library">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog />
    <BulkImageManager :visible.sync="importDialogVisible" />

    <header class="library-header">
      <div>
        <span class="eyebrow">Loja online</span>
        <h1>Imagens</h1>
        <p>Imagens publicadas de equipamentos e produtos.</p>
      </div>
      <Button
        v-if="can('createUpdateParts')"
        icon="pi pi-cloud-upload"
        label="Importar imagens"
        @click="importDialogVisible = true"
      />
    </header>

    <TabView :activeIndex.sync="activeTab" @tab-change="changeTab">
      <TabPanel>
        <template #header>
          <i class="pi pi-desktop p-mr-2"></i>
          <span>Equipamentos</span>
        </template>
        <ImageGalleryPanel
          type="equipment"
          :active="activeTab === 0"
          :refreshToken="refreshTokens.equipment"
          @delete="confirmDelete"
        />
      </TabPanel>
      <TabPanel>
        <template #header>
          <i class="pi pi-box p-mr-2"></i>
          <span>Produtos</span>
        </template>
        <ImageGalleryPanel
          type="product"
          :active="activeTab === 1"
          :refreshToken="refreshTokens.product"
          @delete="confirmDelete"
        />
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import BulkImageManager from "@/components/equipaments/BulkImageManager.vue";
import ImageGalleryPanel from "@/components/equipaments/ImageGalleryPanel.vue";
import sparsService from "@/services/spars.service.js";

export default {
  name: "SparsImages",
  components: { TabView, TabPanel, BulkImageManager, ImageGalleryPanel },
  data() {
    return {
      activeTab: 0,
      importDialogVisible: false,
      refreshTokens: { equipment: 0, product: 0 },
    };
  },
  deactivated() {
    this.importDialogVisible = false;
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    changeTab(event) {
      this.activeTab = event.index;
    },
    confirmDelete(image) {
      const type = this.activeTab === 0 ? "equipment" : "product";
      const entityLabel = image.entities.map(entity => entity.equipment_series || entity.reference).join(", ");
      this.$confirm.require({
        header: "Eliminar imagem",
        message: `Eliminar ${image.file_origin_name || image.file_name} de ${entityLabel}?`,
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Eliminar",
        rejectLabel: "Cancelar",
        acceptClass: "p-button-danger",
        accept: async () => {
          try {
            await sparsService.deleteGalleryImage(type, image.id);
            this.refreshTokens[type] += 1;
            this.$toast.add({ severity: "success", summary: "Imagem eliminada", life: 3000 });
          } catch (error) {
            this.$toast.add({
              severity: "error",
              summary: "Não foi possível eliminar",
              detail: error.response?.data?.message || "Ocorreu um erro ao eliminar a imagem.",
              life: 5000,
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.image-library { min-height: calc(100vh - 8rem); }
.library-header { display: flex; align-items: center; justify-content: space-between; gap: 1.5rem; margin-bottom: 1.25rem; }
.library-header h1 { margin: .15rem 0; color: #163746; }
.library-header p { margin: 0; color: #677984; }
.eyebrow { color: #087f8c; font-size: .7rem; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; }
@media (max-width: 640px) {
  .library-header { align-items: stretch; flex-direction: column; }
}
</style>
